angular.module('internal.inspections')
    .directive('internalInspectionChecklistHeader', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'inspections/components/checklist-header/checklist-header.html',
            controller: 'InternalInspectionChecklistHeader',
            replace: true
        };
    }])
    .controller('InternalInspectionChecklistHeader', ['$scope', '$filter', function ($scope, $filter) {

    }])
;